import { fortiusProfileTheme } from '../../membership/profile/v2/fortiusTheme';
import { bookingRadii } from './bookingTokens';

// Bookings V2 reuses the exact Member Profile V2 Ant theme so the two screens
// read as one product — teal primary, the status trio, radius/control metrics,
// and (deliberately) no font-family override. The v3 handoff calls this out as
// the cleanest path: wrap the bookings surface in the same ConfigProvider theme
// and AntD primitives (Tag, Segmented, Button, Form, Modal) pick up teal for free.
//
// Kept as a re-export (rather than importing fortiusProfileTheme directly in
// every component) so there's a single bookings-side handle if the screens ever
// need to diverge, and so the FORT-178 token unification has one obvious seam.
export const fortiusBookingsTheme = fortiusProfileTheme;

export { bookingRadii };
